module.exports = __webpack_public_path__ + "static/media/speakers.6f2c8632.svg";